import View from './Account';
import enhancer from './Account.enhancer';

const Account = enhancer(View);

export default Account;
